// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-card_checkbox__WIEm6"};